import styled from 'styled-components';
import {
  Link,
} from 'react-router-dom';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const PageWrap = styled(Flex).attrs({
  column: true,
})`
  background-size: cover;
  overflow: auto;
  width: 100%;
  margin: auto;
  min-height: 120px;
  padding-bottom: 15px;

  img {
    max-width: 100%;
  }
`;

export const FormWrap = styled(Flex).attrs({
  column: true,
})`
  width: 90%;
  max-width: 510px;
  margin: 0 auto;
  border: 1px solid #a0a0a0;
  box-shadow: 0 0 12px -6px #000;

  img {
    max-width: 100%;
  }
`;

export const FormTitle = styled(Flex).attrs({
  justify: 'center',
})`
  width: 100%;
  padding: 25px;
  border-radius: 5px 5px 0 0;
  background: #fff;
  color: #121827;
  font-size: 18px;
  font-weight: 900;
`;

export const Form = styled(Flex).attrs({
  as: 'form',
})`
  width: 100%;
  background: #fff;
  padding: 0 30px 25px;
  border-radius: 0 0 5px 5px;
`;

export const SubmitButton = styled(Button).attrs({
  ghost: true,
  type: 'submit',
  appearance: 'primary',
})`
  color: #fff;
  font-size: 18px;
  height: auto;
  padding: 10px 25px;
  border: none;
  background: ${props => props.theme.colors.primaryBright};
  border-radius: 5px;
  width: 100%;
  line-height: 24px;
`;

export const TextCenter = styled(Flex).attrs({
  column: true,
  align: 'center',
  spacing: 5,
})`
  justify-content: center;
  width: 100%;
  text-align: center;
  margin-top: 15px;
`;

export const Reseted = styled(Flex).attrs({
  column: true,
  align: 'center',
  juftyfy: 'center',
  spacing: 15,
})`
  width: 100%;
  background: #fff;
  padding: 0 25px 25px 25px;
  border-radius: 0 0 5px 5px;
  text-align: center;
`;

export const Error = styled.span`
  width: 100%;
  color: ${props => props.theme.colors.danger};
`;

export const BackLink = styled(Link)`
  color: #888;
  font-size: 18px;
  text-align: center;
  line-height: 44px;
  border-radius: 5px;
  background: #fff;
  display: block;
  width: 200px;
  height: 44px;
  margin-right: 15px;
  border: 1px solid #a0a0a0;
`;

export const Separator = styled(Flex).attrs(() => ({
  justify: 'center',
  align: 'center',
}))`
  width: 100%;
  margin: 0 auto;
  color: #121827;
  font-size: 16px;

  &:before {
    content: '';
    display: block;
    height: 1px;
    background: #707070;
    width: 205px;
    margin: 5px 10px 0 0;
  }
  &:after {
    content: '';
    display: block;
    height: 1px;
    background: #707070;
    width: 205px;
    margin: 5px 0 0 10px;
  }
`;
